<template>
  <div>
    <v-dialog v-model="value" persistent max-width="630px" scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <h3>{{ $t('students.modal_download_qr.download_format') }}</h3>
          <v-radio-group row style="justify-content: center" v-model="radio">
            <v-radio label="PDF" value="pdf" color="red"></v-radio>
            <v-radio label="PNG" value="png" color="red"></v-radio>
          </v-radio-group>

          <v-layout
            row
            v-show="this.radio == 'png'"
            style="justify-content: center"
          >
            <span>
              {{ $t('students.modal_download_qr.file_name') }}
            </span>
          </v-layout>
          <v-layout row v-show="std && this.radio == 'png'">
            <v-flex>
              <v-checkbox
                :label="$t('students.modal_download_qr.student_id')"
                value="personId"
                color="red"
                v-model="textStd"
                :rules="rules"
              ></v-checkbox>
            </v-flex>
            <v-flex>
              <v-checkbox
                :label="$t('students.modal_download_qr.first_name')"
                value="firstName"
                color="red"
                v-model="textStd"
                :rules="rules"
              ></v-checkbox>
            </v-flex>
            <v-flex>
              <v-checkbox
                :label="$t('students.modal_download_qr.last_name')"
                value="lastName"
                color="red"
                v-model="textStd"
                :rules="rules"
              ></v-checkbox>
            </v-flex>
            <v-flex>
              <v-checkbox
                :label="$t('students.modal_download_qr.all_of_the_above')"
                v-model="selectAllstd"
                color="red"
                :rules="rules"
              ></v-checkbox>
            </v-flex>
          </v-layout>

          <v-layout row v-show="coll && this.radio == 'png'">
            <v-flex>
              <v-checkbox
                :label="$t('students.modal_download_qr.role')"
                value="webRole"
                color="red"
                v-model="textColl"
                :rules="rulesCol"
              ></v-checkbox>
            </v-flex>
            <v-flex>
              <v-checkbox
                :label="$t('students.modal_download_qr.first_name')"
                value="firstName"
                color="red"
                v-model="textColl"
                :rules="rulesCol"
              ></v-checkbox>
            </v-flex>
            <v-flex>
              <v-checkbox
                :label="$t('students.modal_download_qr.last_name')"
                value="lastName"
                color="red"
                v-model="textColl"
                :rules="rulesCol"
              ></v-checkbox>
            </v-flex>
            <v-flex>
              <v-checkbox
                :label="$t('students.modal_download_qr.all_of_the_above')"
                v-model="selectAllcoll"
                color="red"
                :rules="rules"
              ></v-checkbox>
            </v-flex>
          </v-layout>

          <v-container grid-list-md v-show="this.radio == 'pdf'">
            <v-layout row wrap justify-center>
              <v-flex xs12 mt-4>
                <v-slider
                  :label="$t('students.modal_download_qr.qr_code_size')"
                  v-model="size"
                  max="360"
                  min="120"
                  thumb-color="red"
                  step="240"
                  ticks="always"
                  tick-size="2"
                  thumb-size="50"
                  thumb-label="always"
                >
                  <template v-slot:thumb-label="props">
                    <span>
                      {{ thumbText() }}
                    </span>
                  </template>
                </v-slider>
              </v-flex>
              <v-flex xs12>
                <div color="primary">
                  {{
                    `${$t('students.modal_download_qr.qr_code_size')} ${
                      size == 120 ? '12' : '9'
                    } ${$t('students.modal_download_qr.qr_code_size_2')}`
                  }}
                </div>
              </v-flex>
              <v-flex xs12>
                <div>
                  <v-checkbox
                    color="primary"
                    id="required"
                    v-model="space"
                    :label="textLinebreak"
                  />
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="working.wUpdate" flat @click="close">
            {{ $t('students.modal_download_qr.cancel') }}
          </v-btn>
          <v-btn
            v-show="this.radio == 'pdf'"
            :disabled="working.wUpdate"
            color="primary darken-1"
            flat
            @click="submit"
          >
            {{ $t('students.modal_download_qr.download_pdf') }}
          </v-btn>
          <v-btn
            v-show="this.radio == 'png'"
            :disabled="working.wUpdate"
            color="primary darken-1"
            flat
            @click="submitImg"
          >
            {{ $t('students.modal_download_qr.download_png') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['title', 'value', 'std', 'coll'],
  data: () => ({
    radio: null,
    textStd: ['personId'],
    textColl: ['webRole'],
    modals: {},
    size: 120,
    space: false,
    working: {
      wUpdate: false,
      wImage: false,
    },
    toast: {
      success: false,
      failed: false,
    },
    allTypestd: ['personId', 'firstName', 'lastName'],
    allTypecoll: ['webRole', 'firstName', 'lastName'],
  }),
  methods: {
    thumbText() {
      if (this.size == 120)
        return `${this.$t('students.modal_download_qr.small')}`
      return this.$t('students.modal_download_qr.large')
    },
    close() {
      this.radio = null
      try {
        document.getElementById('img_edit_employee').innerHTML = ``
        document.getElementById('img_edit_employee').style.display = 'none'
        document
          .getElementById('parentContainerEmployeeImage')
          .classList.add('gradiente')
        document.getElementById('img_edit_employee_default').style.display =
          'block'
      } catch (error) {
        console.log(error)
      } finally {
        this.$emit('input', !this.value)
      }
    },
    submit() {
      this.radio = null
      this.$emit('desition', {
        value: true,
        size: this.size,
        space: this.space,
      })
    },
    submitImg() {
      if (this.std && this.textStd.length > 0) {
        this.$emit('archivoName', { std: this.textStd, coll: this.textColl })
        this.$emit('desitionImg')
        this.textStd = ['personId']
      }
      if (this.coll && this.textColl.length > 0) {
        this.$emit('archivoName', { std: this.textStd, coll: this.textColl })
        this.$emit('desitionImg')
        this.textColl = ['webRole']
      }
    },
  },
  computed: {
    textLinebreak() {
      return this.std
        ? this.$t('students.modal_download_qr.page_breaks_groups')
        : this.$t('generic.modal_qr.page_breaks_groups')
    },
    rules() {
      return [this.textStd.length > 0 || 'Selecciona al menos una opción']
    },
    rulesCol() {
      return [this.textColl.length > 0 || 'Selecciona al menos una opción']
    },
    selectAllstd: {
      get: function () {
        return this.allTypestd
          ? this.textStd.length == this.allTypestd.length
          : false
      },
      set: function (value) {
        var textStd = []
        if (value) {
          this.allTypestd.forEach(function (type) {
            textStd.push(type)
          })
        }
        this.textStd = textStd
      },
    },
    selectAllcoll: {
      get: function () {
        return this.allTypecoll
          ? this.textColl.length == this.allTypecoll.length
          : false
      },
      set: function (value) {
        var textColl = []
        if (value) {
          this.allTypecoll.forEach(function (type) {
            textColl.push(type)
          })
        }
        this.textColl = textColl
      },
    },
  },
}
</script>
<style>
.imgQrPadding {
  padding-left: 10%;
}
</style>
